import { About, Tabs } from "./components";

export default function AboutPage() {
  return (
    <div className="bg-[#F5F2E4]">
      <About />
      <div className="mt-6 sm:mt-8 md:mt-10 px-4 sm:px-6 md:px-8">
        <h4 className="border-t-4 pt-2 border-primary inline-block text-xl sm:text-2xl md:text-3xl">
          Filosofía
        </h4>
        <Tabs
          tabs={[
            {
              key: "mision",
              title: "Misión",
              content:
                `
                En Vegan Vegetarian creemos que comer es un acto de amor: hacia uno mismo, hacia los demás y hacia el planeta. Nuestra misión es demostrar que una alimentación vegetariana puede ser saludable, sostenible y profundamente deliciosa. Queremos llevar a cada hogar platillos y productos que unan lo mejor del sabor con lo mejor del bienestar, derribando la idea de que comer sano significa renunciar al placer.
                \n
                Con más de tres décadas de experiencia, creamos recetas originales inspiradas en distintas culturas, siempre guiados por la convicción de que se puede comer rico y vivir mejor. Nuestro compromiso es ofrecer alimentos que nutran el cuerpo, fortalezcan el espíritu y promuevan un futuro más consciente para las familias y comunidades que confiaron en nosotros.
                En esencia, nuestra misión es compartir salud con sabor, y hacerlo con honestidad, pasión y corazón.
                `,
            },
            {
              key: "vision",
              title: "Visión",
              content:
                `
                Ser una marca referente en la gastronomía vegetariana, reconocida por demostrar que la comida saludable puede ser también la más deliciosa. Queremos inspirar a las personas y familias a transformar su manera de alimentarse, cultivando una cultura de bienestar, sabor y conciencia que trascienda generaciones.
                Soñamos con un mundo en el que elegir lo vegetariano no sea una limitación, sino una celebración de la vida: de la salud, de la comunidad y del planeta.
                \n
                Nuestra visión es llegar a cada hogar con productos y platillos que unan tradición, creatividad y amor por la cocina, contribuyendo a un futuro más sostenible, humano y lleno de sabor.
                `,
            },
            {
              key: "valores",
              title: "Valores",
              content:
              `
              - Pasión por el sabor
               Creemos que comer sano nunca debe significar renunciar al placer. Cada receta nace con amor y creatividad para sorprender al paladar.
              - Salud consciente 
              Buscamos nutrir el cuerpo y el alma con alimentos que promuevan bienestar, energía y equilibrio.
              - Sostenibilidad
              Respetamos al planeta en cada paso, fomentando un estilo de vida que cuida la naturaleza y el futuro de las próximas generaciones.
              - Autenticidad
              Nuestros productos reflejan quiénes somos: una historia de disciplina, resiliencia y corazón, siempre con transparencia y honestidad.
              - Innovación con raíces
              Honramos la tradición culinaria mientras exploramos nuevas formas de crear platillos originales, saludables y memorables.
              - Cercanía y comunidad
              Más que clientes, buscamos construir una familia alrededor de la mesa, compartiendo experiencias, apoyo y confianza.
              `,
            },
          ]}
        />
      </div>
    </div>
  );
}
